/*
    Config files for the links on the product selection page
*/

import { ScoutFeature } from "../../../../../Enums/ScoutFeature";
import { App } from "../../../Enums/App";
import { LinkType } from "../../../Enums/LinkType";
import { appFeatureLookup } from "../../../Logic/AppLogic";
import { ILinkObject } from "../../../Models/ILinkObject";
import { createEnvUrlString, createEnvUrlStringForPersona } from "../../../../../Logic/EnvLogic";

export const linkListConfig = (featureAccess: string[]): ILinkObject[] => ([
    {
        type: LinkType.SCOUT,
        requiredFeatures: appFeatureLookup.get(App.Scout),
        title: "SCOUT",
        link: "Home/Scout",
        externalLink: `${window.location.origin}/Home/Scout`,
        icon: "/Images/products/Scout.svg",
        quickLinksIcon: "/Images/products/ScoutIcon.svg",
        hoveredQuickLinksIcon: "/Images/products/ScoutIcon.svg",
        hoveredIcon: "/Images/products/Scout_Hover.svg",
        hoverData: {
            image: "/Images/products/Scout.svg",
            header: "",
            description: "Visualize and analyze market dynamics and performance drivers.",
        },
        noAccessData: {
            icon: "/Images/products/Scout_Lock.svg",
            hoveredIcon: "/Images/products/Scout_Hover_Lock.svg",
            quickLinksIcon: "/Images/products/Scout_Lock.svg",
            hoveredQuickLinksIcon: "/Images/products/Scout_Hover_Lock.svg",
            walkMe: true,
            description: "No access to SCOUT.",
            link: "https://www.buxtonco.com/",
            linkText: "Create Account"
        },
        app: App.Scout,
        shortTitle: "SCOUT",
        exists: true,
    },
    {
        type: LinkType.Internal,
        requiredFeatures: appFeatureLookup.get(App.Match),
        title: "match",
        link: "Match",
        externalLink: `${window.location.origin}/Products#/Match`,
        icon: "/Images/products/Match.svg",
        quickLinksIcon: "/Images/products/MatchIcon.svg",
        hoveredQuickLinksIcon: "/Images/products/MatchIcon.svg",
        hoveredIcon: "/Images/products/Match_Hover.svg",
        hoverData: {
            image: "/Images/products/Match.svg",
            header: "",
            description: "Identify and attract best fit brands to any location.",
        },
        noAccessData: {
            icon: "/Images/products/Match_Lock.svg",
            hoveredIcon: "/Images/products/Match_Hover_Lock.svg",
            quickLinksIcon: "/Images/products/Match_Lock.svg",
            hoveredQuickLinksIcon: "/Images/products/Match_Hover_Lock.svg",
            walkMe: true,
            description: "No access to Match.",
            link: "https://www.buxtonco.com/",
            linkText: "Create Account"
        },
        app: App.Match,
        shortTitle: "Match",
        exists: true,
    },
    {
        type: LinkType.External,
        requiredFeatures: appFeatureLookup.get(App.Mobilytics),
        title: "mobilytics",
        link: "Mobilytics",
        externalLink: `${window.location.origin}/Products#/Mobilytics`,
        icon: "/Images/products/Mobilytics.svg",
        quickLinksIcon: "/Images/products/MobilyticsIcon.svg",
        hoveredQuickLinksIcon: "/Images/products/MobilyticsIcon.svg",
        hoveredIcon: "/Images/products/Mobilytics_Hover.svg",
        hoverData: {
            image: "/Images/products/Mobilytics.svg",
            header: "",
            description: "Analyze mobile foot traffic data with extreme precision.",
        },
        noAccessData: {
            icon: "/Images/products/Mobilytics_Lock.svg",
            hoveredIcon: "/Images/products/Mobilytics_Hover_Lock.svg",
            quickLinksIcon: "/Images/products/Mobilytics_Lock.svg",
            hoveredQuickLinksIcon: "/Images/products/Mobilytics_Hover_Lock.svg",
            walkMe: true,
            description: "No access to Mobilytics",
            link: "https://www.buxtonco.com/",
            linkText: "Create Account"
        },
        app: App.Mobilytics,
        shortTitle: "Mobilytics",
        exists: true,
    },
    {
        type: LinkType.External,
        requiredFeatures: appFeatureLookup.get(App.Factor),
        title: "factor",
        link: createEnvUrlString() === "-dev"
            ? "https://localhost:9001"
            : `https://factor${createEnvUrlString()}.buxtonco.com`,
        externalLink: createEnvUrlString() === "-dev"
            ? "https://localhost:9001"
            : `https://factor${createEnvUrlString()}.buxtonco.com`,
        icon: "/Images/products/Factor.svg",
        quickLinksIcon: "/Images/products/Factor.svg",
        hoveredQuickLinksIcon: "/Images/products/Factor.svg",
        hoveredIcon: "/Images/products/Factor_Hover.svg",
        hoverData: {
            image: "/Images/products/Factor.svg",
            header: "",
            description: "Analyze site selection factors and discover market expansion opportunities.",
        },
        noAccessData: {
            icon: "/Images/products/Factor_Lock.svg",
            hoveredIcon: "/Images/products/Factor_Hover_Lock.svg",
            quickLinksIcon: "/Images/products/Factor_Lock.svg",
            hoveredQuickLinksIcon: "/Images/products/Factor_Hover_Lock.svg",
            walkMe: true,
            description: "No access to Factor.",
            link: "https://www.buxtonco.com/",
            linkText: "Create Account"
        },
        app: App.Factor,
        shortTitle: "Factor",
        exists: true,
    },
    {
        type: LinkType.External,
        requiredFeatures: appFeatureLookup.get(App.Iq),
        title: "IQ",
        link: createEnvUrlString() === "-dev"
            ? "http://localhost:7000"
            : `https://iq${createEnvUrlString()}.buxtonco.com`,
        externalLink: createEnvUrlString() === "-dev"
            ? "http://localhost:7000"
            : `https://iq${createEnvUrlString()}.buxtonco.com`,
        icon: "/Images/products/IQ.svg",
        quickLinksIcon: "/Images/products/IQ.svg",
        hoveredQuickLinksIcon: "/Images/products/IQ.svg",
        hoveredIcon: "/Images/products/IQ.svg",
        hoverData: {
            image: "/Images/products/IQ.svg",
            header: "",
            description: "Query your data and Buxton’s data for answers on demand.",
        },
        noAccessData: {
            icon: "/Images/products/IQ.svg",
            hoveredIcon: "/Images/products/IQ.svg",
            quickLinksIcon: "/Images/products/IQ.svg",
            hoveredQuickLinksIcon: "/Images/products/IQ.svg",
            walkMe: true,
            description: "No access to IQ.",
            link: "https://www.buxtonco.com/",
            linkText: "Create Account"
        },
        app: App.Iq,
        shortTitle: "IQ",
        exists: true,
    },
    {
        type: LinkType.MULTI,
        requiredFeatures: appFeatureLookup.get(App.MyReports),
        title: "my reports",
        link: "MyReports",
        externalLink: featureAccess.indexOf(ScoutFeature.Scout4) > -1
            ? `${window.location.origin}/Home/Scout#/reports`
            : `${window.location.origin}/Products#/MyReports`,
        icon: "/Images/products/MyReport.svg",
        quickLinksIcon: "/Images/products/MyReport.svg",
        hoveredQuickLinksIcon: "/Images/products/MyReport.svg",
        hoveredIcon: "/Images/products/MyReport_Hover.svg",
        hoverData: {
            image: "/Images/products/MyReport.svg",
            header: "",
            description: "Access all of your reports with ease.",
        },
        noAccessData: {
            icon: "/Images/products/MyReport_Lock.svg",
            hoveredIcon: "/Images/products/MyReport_Hover_Lock.svg",
            quickLinksIcon: "/Images/products/MyReport_Lock.svg",
            hoveredQuickLinksIcon: "/Images/products/MyReport_Hover_Lock.svg",
            walkMe: true,
            description: "No access to My Reports.",
            link: "https://www.buxtonco.com/",
            linkText: "Create Account"
        },
        app: App.MyReports,
        shortTitle: "My Reports",
        exists: true,
    },
    {
        type: LinkType.External,
        requiredFeatures: appFeatureLookup.get(App.Persona),
        title: "personas+",
        link: `https://go${createEnvUrlStringForPersona()}.buxtonco.com`,
        externalLink: `https://go${createEnvUrlStringForPersona()}.buxtonco.com`,
        icon: "/Images/products/Persona.svg",
        quickLinksIcon: "/Images/products/QL_Persona.svg",
        hoveredQuickLinksIcon: "/Images/products/QL_Hovered_Persona.svg",
        hoveredIcon: "/Images/products/Persona_Hover.svg",
        hoverData: {
            image: "/Images/products/Persona.svg",
            header: "",
            description: "Leverage AI-powered personas to transform your marketing strategy with deep audience insights and tracking. Access detailed behavioral profiles and trends, preference patterns, and engagement opportunities of customers and visitors.",
        },
        noAccessData: {
            icon: "/Images/products/Persona_Lock.svg",
            hoveredIcon: "/Images/products/Persona_Hover_Lock.svg",
            quickLinksIcon: "/Images/products/QL_Persona_Locked.svg",
            hoveredQuickLinksIcon: "/Images/products/QL_Hovered_Persona_Locked.svg",
            walkMe: true,
            description: "No access to Persona+",
            link: "https://www.buxtonco.com/",
            linkText: "Create Account",
        },
        app: App.Persona,
        shortTitle: "Personas+",
        exists: false,
    },
]);
